// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Outlets-List-OutletDetail-__OutletDetail___2-5-O","form":"app-pages-Outlets-List-OutletDetail-__OutletDetail___K89Yq"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Outlets/List/OutletDetail/OutletDetail.css
// module id = 2204
// module chunks = 0